
import { createApi } from 'permits/shared/api';

export default createApi('/users/api'); 